import { Related } from '@/components/blogHome/Related';
import { Summary } from '@/components/blogHome/Summary';
import { Content } from '@prismicio/client';
import { SliceComponentProps, SliceZone } from '@prismicio/react';
import { BlogCategoryDocument } from '../../../prismicio-types';
import { HorizontalCategoriesSearch } from '../../components/blogHome/HorizontalCategoriesSearch';

/**
 * Props for `BlogHomeComponentSelector`.
 */
export type BlogHomeComponentSelectorProps = SliceComponentProps<
  Content.BlogHomeComponentSelectorSlice,
  {
    category?: string;
    categories: BlogCategoryDocument[];
    readBlog?: string;
    page: number;
  }
>;

/**
 * Component for "BlogHomeComponentSelector" Slices.
 */
const BlogHomeComponentSelector = (
  props: BlogHomeComponentSelectorProps,
): JSX.Element => {
  if (props.slice.primary.component === 'Featured') {
    return <SliceZone {...props} />;
  }
  if (props.slice.primary.component === 'Related') {
    return (
      <div className="max-w-screen-2xl mx-auto">
        <Related readBlog={props.context.readBlog} />
      </div>
    );
  }
  return (
    <div className="w-full">
      <div className="max-w-[1300px] mx-auto px-6 md:px-8">
        <div className="flex gap-x-16 gap-y-8 flex-col pt-6 md:pt-6 w-full justify-between text-white">
          <HorizontalCategoriesSearch
            selectedCategory={props.context.category}
            categories={props.context.categories}
          />
          <Summary
            selectedCategory={props.context.category}
            page={props.context.page}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogHomeComponentSelector;
